"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Tag = Tag;
exports.addTag = addTag;
exports.removeLastTag = removeLastTag;
exports.removeTag = removeTag;

var _includes2 = _interopRequireDefault(require("lodash/includes"));

var _concat2 = _interopRequireDefault(require("lodash/concat"));

var _compact2 = _interopRequireDefault(require("lodash/compact"));

var _iconButton = require("./buttons/icon-button");

var _typography = require("./typography");

var _styles = require("react-components/styles");

var _styledTools = require("styled-tools");

var _dom = require("@slyk/dom");

var _reactForms = require("@seegno/react-forms");

var _i18n = require("@slyk/i18n");

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/**
 * Module dependencies.
 */
var closeIcon = "<svg fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\"><path d=\"M13.25 2.75l-10.5 10.5m10.5 0L2.75 2.75\" stroke=\"currentColor\" stroke-miterlimit=\"10\"/></svg>";

/**
 * Export `addTag`.
 */
function addTag(tags, tag, callback) {
  if (!(0, _includes2["default"])(tags, tag)) {
    var newTags = (0, _compact2["default"])((0, _concat2["default"])(tags, tag));

    if (callback) {
      callback(newTags);
    }
  }
}
/**
 * Export `removeTag`.
 */


function removeTag(tags, tag) {
  if (!tags) {
    return;
  }

  return tags.length > 1 ? tags.filter(function (item) {
    return item !== tag;
  }) : undefined;
}
/**
 * Export `removeLastTag`.
 */


function removeLastTag(tags) {
  if (!tags) {
    return;
  }

  return tags.length > 1 ? tags.slice(0, tags.length - 1) : undefined;
}
/**
 * `TagWrapper` styled component.
 */


var TagWrapper = _styledComponents["default"].div.withConfig({
  displayName: "tag__TagWrapper",
  componentId: "sc-28rcm7-0"
})(["align-items:center;background-color:", ";border-radius:16px;color:", ";column-gap:8px;display:flex;justify-content:center;padding:4px 16px;transition:", ";transition-property:background-color,color,opacity;", " ", ""], _styles.color.transparentize('primary', 0.1), (0, _styles.color)('primary'), (0, _styledTools.theme)('transitions.defaultTransition'), (0, _styledTools.ifProp)('hasError', (0, _styledComponents.css)(["background-color:", ";color:", ";"], (0, _styles.color)('danger100'), (0, _styles.color)('danger'))), (0, _styledTools.ifProp)('disabled', (0, _styledComponents.css)(["opacity:0.55;"])));
/**
 * Export `Tag` component.
 */


function Tag(props) {
  var className = props.className,
      disabled = props.disabled,
      name = props.name,
      onRemove = props.onRemove,
      value = props.value;

  var _useTranslate = (0, _i18n.useTranslate)(),
      translate = _useTranslate.translate;

  var _useFieldState = (0, _reactForms.useFieldState)(name),
      error = _useFieldState.error;

  return /*#__PURE__*/_react["default"].createElement(TagWrapper, {
    className: className,
    disabled: disabled,
    hasError: !!error,
    onClick: _dom.stopPropagation
  }, /*#__PURE__*/_react["default"].createElement(_typography.Text, {
    as: 'span',
    size: 'normal'
  }, value), /*#__PURE__*/_react["default"].createElement(_iconButton.IconButton, {
    "aria-label": translate('common.actions.delete'),
    colorTheme: 'transparent',
    disabled: disabled,
    icon: closeIcon,
    iconSize: '16px',
    onClick: onRemove,
    size: '16px',
    type: 'button'
  }));
}